import React from 'react'

import './styles.scss'

const Media = () => {
	return (
		<>
			<img src="/images/prediction/baby.png" className="none-media" />
			<img src="/images/prediction/marry.png" className="none-media" />
			<video
				muted
				type="video/mp4"
				src="/videos/prediction/baby.mp4"
				className="none-media"
			/>
			<video
				muted
				type="video/mp4"
				src="/videos/prediction/boy-girl.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/prediction/bride.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/prediction/marry.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/sale/brides.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/sale/mother.np4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/filters/avaratify.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/filters/cartoonify.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/filters/ageing.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/filters/babyfy.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/filters/elfy.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/filters/zombify.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/sale/ad.mp4"
				className="none-media"
			/>
			<video
				type="video/mp4"
				muted
				src="/videos/sale/royal-family.mp4"
				className="none-media"
			/>
			<img src="/images/common/refine-icon-min.png" className="none-media" />
			<img
				src="/images/questions/predictions/bride.png"
				className="none-media"
			/>
			<img
				src="/images/questions/predictions/boy-girl.png"
				className="none-media"
			/>
			<img src="/images/sale/brides.png" className="none-media" />
			<img src="/images/sale/mother.png" className="none-media" />
			<img
				src="/images/common/emojis/movie-camera-min.png"
				className="none-media"
			/>
			<img src="/images/common/emojis/nerd-min.png" className="none-media" />
			<img
				src="/images/common/emojis/photo-camera-min.png"
				className="none-media"
			/>
			<img
				src="/images/common/emojis/smirking-min.png"
				className="none-media"
			/>
			<img
				src="/images/common/emojis/star-struck-min.png"
				className="none-media"
			/>
			<img
				src="/images/common/emojis/sunglasses-min.png"
				className="none-media"
			/>
			<img
				src="/images/common/emojis/lovely-eyes-min.png"
				className="none-media"
			/>
			<img src="/images/common/emojis/cool-min.png" className="none-media" />
			<img src="/images/common/emojis/silence-min.png" className="none-media" />
			<img src="/images/common/emojis/blush-min.png" className="none-media" />
			<img src="/images/home/stars-min.png" className="none-media" />
			<img src="/images/home/girl-min.png" className="none-media" />
			<img src="/images/home/pen-min.png" className="none-media" />
			<img src="/images/home/slider/image0-min.png" className="none-media" />
			<img src="/images/home/slider/image1-min.png" className="none-media" />
			<img src="/images/home/slider/image2-min.png" className="none-media" />
			<img src="/images/home/slider/image3-min.png" className="none-media" />
			<img src="/images/home/slider/image4-min.png" className="none-media" />
			<img src="/images/home/slider/image5-min.png" className="none-media" />
			<img src="/images/home/slider/image6-min.png" className="none-media" />
			<img src="/images/home/slider/slide1.png" className="none-media" />
			<img src="/images/home/slider/slide2.png" className="none-media" />
			<img src="/images/home/slider/slide3.png" className="none-media" />
			<img src="/images/home/slider/ork1.png" className="none-media" />
			<img src="/images/home/slider/ork2.png" className="none-media" />
			<img src="/images/home/slider/ork3.png" className="none-media" />
			<img src="/images/home/slider/ork4.png" className="none-media" />
			<img src="/images/home/slider/ork5.png" className="none-media" />
			<img src="/images/home/slider/ork6.png" className="none-media" />
			<img src="/images/questions/0.png" className="none-media" />
			<img src="/images/questions/1.png" className="none-media" />
			<img src="/images/questions/2.png" className="none-media" />
			<img src="/images/questions/3.png" className="none-media" />
			<img src="/images/processing/people.png" className="none-media" />
			<img src="/images/processing/rating.png" className="none-media" />
			<img src="/images/sale/apple-winner.png" className="none-media" />
			<img src="/images/sale/cartoonify-image.png" className="none-media" />
			<img src="/images/sale/colors1-bg.png" className="none-media" />
			<img src="/images/sale/colors2-bg.png" className="none-media" />
			<img src="/images/sale/colors3-bg.png" className="none-media" />
			<img src="/images/sale/colors4-bg.png" className="none-media" />
			<img src="/images/sale/dark-forest-bg.png" className="none-media" />
			<img src="/images/sale/edit-man.png" className="none-media" />
			<img src="/images/sale/faces-in-circles.png" className="none-media" />
			<img src="/images/sale/footer-logos.png" className="none-media" />
			<img src="/images/sale/global-rating.png" className="none-media" />
			<img src="/images/sale/lock.png" className="none-media" />
			<img src="/images/sale/phone-frame-small.png" className="none-media" />
			<img src="/images/sale/phone-frame.png" className="none-media" />
			<img src="/images/sale/pick-icon.png" className="none-media" />
			<img src="/images/sale/pink-sky-bg.png" className="none-media" />
			<img src="/images/sale/rainbow-bg.png" className="none-media" />
			<img src="/images/sale/share-friends.png" className="none-media" />
			<img src="/images/sale/stars-rating.png" className="none-media" />
			<img src="/images/sale/user-image.png" className="none-media" />
			<img src="/images/sale/pink-back.png" className="none-media" />
			<img src="/images/sale/price-bg.png" className="none-media" />
			<img src="/images/sale/rosette.png" className="none-media" />
			<img src="/images/discount/comment1.png" className="none-media" />
			<img src="/images/discount/comment2.png" className="none-media" />
			<img src="/images/discount/price.png" className="none-media" />
			<img src="/images/success/download-apple.png" className="none-media" />
			<img src="/images/success/download-google.png" className="none-media" />
			<img src="/images/upsell/upsell1.png" className="none-media" />
			<img src="/images/upsell/upsell2.png" className="none-media" />
			<img src="/images/upsell/upsell3.png" className="none-media" />
			<img src="/images/upsell/upsell4.png" className="none-media" />
			<img src="/images/upsell/pick.png" className="none-media" />
			<img src="/images/bag/pick.png" className="none-media" />
			<img src="/images/bag/shopping-bags.png" className="none-media" />
			<img src="/images/success/step2.png" className="none-media" />
			<img src="/images/error/error.png" className="none-media" />
			<img
				src="/images/questions/predictions/2/Angelina Jolie.png"
				className="none-media"
			/>
			<img
				src="/images/questions/predictions/2/Hillary Duff.png"
				className="none-media"
			/>
			<img
				src="/images/questions/predictions/2/Mila Kunis.png"
				className="none-media"
			/>
			<img
				src="/images/questions/predictions/2/Taylor Swift.png"
				className="none-media"
			/>
			<img
				src="/images/questions/predictions/3/family.png"
				className="none-media"
			/>
			<img
				src="/images/questions/predictions/7/patience.png"
				className="none-media"
			/>
			<img
				src="/images/questions/predictions/9/keys.png"
				className="none-media"
			/>
			<img src="/images/unsubscribe/offer.png" className="none-media" />
		</>
	)
}

export { Media }
